import React, { useState, useEffect } from "react";
// import "./HomeContainer.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { toast } from "react-toastify";
import API_BASE_URL from "../../../config/api";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext"; // Import the useAuth hook
import axios from "axios";

function HomeContainer() {
    const navigate = useNavigate();
    const { user, isAuthenticated } = useAuth(); // Get user from Auth Context
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);

    const truncateText = (text, maxLength) => {
        if (!text) return "";
        return text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Use Auth Context instead of localStorage
                if (!isAuthenticated || !user) {
                    console.error("No authenticated user found");
                    toast.error("Please log in to view your projects");
                    navigate("/");
                    return;
                }

                // Get the email from the user object
                const userEmail = user.email;

                if (!userEmail) {
                    console.error("No email found for user:", user);
                    toast.error("User email not found. Please contact support.");
                    return;
                }

                // console.log("Fetching projects for student with email:", userEmail);

                // Fetch projects by student email
                const projectsResponse = await axios.get(
                    `${API_BASE_URL}/api/projects/student/email/${encodeURIComponent(userEmail)}`
                );

                // console.log("Projects response:", projectsResponse.data);

                // Update to handle the new response structure
                if (projectsResponse.data.success) {
                    setProjects(projectsResponse.data.data);
                } else {
                    console.error("API returned unsuccessful response:", projectsResponse.data);
                    toast.error(projectsResponse.data.message || "Error loading projects");
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                console.error("Response data:", error.response?.data);
                console.error("Status:", error.response?.status);

                // More informative error message
                const errorMessage =
                    error.response?.data?.message ||
                    "Error loading projects. Please try again.";
                toast.error(errorMessage);

                // If unauthorized, redirect to login
                if (error.response?.status === 401) {
                    toast.error(
                        "Your session has expired. Please log in again."
                    );
                    navigate("/");
                }
            } finally {
                setLoading(false);
            }
        };

        if (isAuthenticated) {
            fetchData();
        }

        AOS.init({ duration: 1000 });
    }, [isAuthenticated, user, navigate]);

    // Update navigation methods to use React Router instead of window.location
    const gotoaddproject = () => {
        navigate("/student/addproject");
    };

    const gotoGuides = () => {
        navigate("/student/guides");
    };

    const viewProject = (projectId) => {
        navigate(`/project/${projectId}`);
    };

    // const renderPlaceholders = () => {
    //     if (loading || projects.length >= 3) return [];

    //     const count = 3 - projects.length;
    //     return Array(count)
    //         .fill(0)
    //         .map((_, index) => (
    //             <div
    //                 key={`placeholder-${index}`}
    //                 className="cardone placeholder"
    //                 onClick={gotoaddproject}
    //             >
    //                 <div className="placeholder-content">
    //                     <div className="plus-icon">+</div>
    //                     <div className="placeholder-text">Add New Project</div>
    //                     <div className="placeholder-subtext">{`(${projects.length}/3 Projects Used)`}</div>
    //                 </div>
    //             </div>
    //         ));
    // };

    return (
        <div className="flex flex-col p-6 min-h-[90vh] md:p-12">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 pb-4 gap-4">
                <div className="text-3xl md:text-4xl font-bold pb-2 border-b-2 border-[#b7202e] w-fit text-black" data-aos="zoom-in">
                    Your Proposals
                </div>
                <div className="flex gap-4 w-full md:w-auto">
                    <button
                        className="w-full md:w-auto bg-[#b7202e] text-white rounded-lg border-0 text-base py-3 px-5 cursor-pointer transition-all hover:bg-[#930d19] hover:-translate-y-0.5 shadow-sm font-bold"
                        onClick={gotoGuides}
                    >
                        See Guides
                    </button>
                </div>
            </div>

            <div className="flex-grow">
                {loading ? (
                    <div className="text-center text-[#666] p-10 text-lg">Loading projects...</div>
                ) : projects.length === 0 ? (
                    <div className="flex flex-col items-center justify-center p-10 bg-[#f9f9f9] rounded-xl text-center">
                        <p className="text-[#666] text-lg mb-4">You haven't created any project proposals yet.</p>
                        <button
                            className="bg-[#506eec] text-white border-0 py-2.5 px-6 rounded-lg cursor-pointer font-medium transition-all hover:bg-[#3a5bbf] hover:-translate-y-0.5 shadow-md"
                            onClick={gotoaddproject}
                        >
                            Create Your First Project
                        </button>
                    </div>
                ) : (
                    <div className="flex flex-wrap gap-6 w-full">
                        <>
                            {projects.map((project, index) => (
                                <div
                                    key={project._id || index}
                                    className="flex-1 w-full bg-white rounded-xl p-6 shadow-md transition-all duration-300 border-l-[5px] border-l-[#b7202e] hover:-translate-y-1 hover:shadow-lg flex flex-col gap-4"
                                    data-aos="fade-up"
                                    data-aos-delay={index * 100}
                                >
                                    <div className="flex flex-col gap-4">
                                        <div
                                            className="text-2xl text-[#333] border-b-2 border-[#161dc7] pb-2 font-bold"
                                        >
                                            {truncateText(
                                                project.projectTitle,
                                                50
                                            )}
                                        </div>

                                        <div className="text-[#666] capitalize font-semibold text-sm">
                                            Category:{" "}
                                            {truncateText(
                                                Object.entries(project.category)
                                                    .filter(
                                                        ([_, value]) =>
                                                            value === true
                                                    )
                                                    .map(([key]) => key)
                                                    .join(", "),
                                                40
                                            )}
                                        </div>

                                        <div className="text-[#161dc7] px-2 py-1 bg-[#161dc71a] rounded inline-block font-semibold text-sm w-fit">
                                            Status: {project.status}
                                        </div>


                                        <div className="font-semibold text-[#333] text-sm">
                                            Team Members:
                                            <ul className="list-none flex flex-wrap mt-1 space-y-1 text-[#666] font-normal px-0">
                                                {project.teamMembers.map(
                                                    (member, idx) => (
                                                        <li className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-full text-xs font-medium text-gray-700 shadow-sm border border-gray-200" key={idx}>
                                                            {truncateText(
                                                                member,
                                                                25
                                                            )}
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </div>

                                        <div className="text-[#888] text-xs font-semibold">
                                            Created:{" "}
                                            {new Date(
                                                project.date
                                            ).toLocaleDateString("en-IN", {
                                                day: 'numeric', month: 'numeric', year: 'numeric'
                                            })}
                                        </div>
                                        <button
                                            className="bg-[#506eec] text-white border-0 py-2 px-4 rounded-md cursor-pointer font-medium self-start transition-all hover:bg-[#3a5bbf] hover:-translate-y-0.5 text-sm mt-auto"
                                            onClick={() =>
                                                viewProject(
                                                    project._id || index
                                                )
                                            }
                                        >
                                            View Project Details
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </>
                    </div>
                )}
            </div>
        </div>
    );
}

export default HomeContainer;
